import { Button } from "@chakra-ui/button";
import { MenuButton, MenuItem } from "@chakra-ui/menu";
import styled from "styled-components";
import { Colors } from "../utils/colors";

export const TopBar = styled.div`
  display: flex;
  padding: 10px;
  background-color: ${Colors.white};
  color: ${Colors.white};
  align-items: center;
  justify-content: space-between;
  padding: 20px 40px;
`;

export const MenuTopBar = styled(TopBar)`
  background-color: ${Colors.blue};
`;

export const TopButtons = styled.div``;

export const TopButton = styled(Button)`
  color: ${Colors.blue};
  margin-left: 10px;
`;
export const MenuTopBarLink = styled.a`
  color: ${Colors.white};
  padding: 10px 20px;
  font-size: 18px;
  font-weight: 600;
`;

export const Logo = styled.div`
  flex: 0 1 241px;
  margin-left: 8px;
  color: ${Colors.white};
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;
`;

export const TranslateInput = styled.input`
  padding: 8px 8px 8px 16px;
  background-color: ${Colors.white};
  color: ${Colors.white};
  border: none;
  flex: 0 0 200px;
  border-radius: 20px;
  margin: 2px 0;
`;

export const UserMenuButton = styled(MenuButton)`
  color: ${Colors.white};
  padding: 10px 20px;
  font-size: 18px;
  font-weight: 600;
  svg {
    padding-top: 4px;
    display: inline;
  }
`;

export const SignoutButton = styled(MenuItem)`
  && {
    color: ${Colors.black};
  }
`;

export const Hero = styled.div`
  min-height: 380px;
  background-image: url("//www.healthcare.gov/images/hero/0e9_starts_homepage_hero.png");
  background-size: cover;
  background-position-x: right;
`;
export const HeadingOne = styled.div`
  color: ${Colors.white};
  font-family: "Open Sans", sans-serif;
  font-size: 60px;
  line-height: 67px;
  letter-spacing: -2px;
  width: 650px;
  margin: 0px 150px;
  padding-top: 40px;
`;
export const CallToActions = styled.div`
  margin: 0px 150px;
  padding-top: 40px;
  display: flex;
`;
export const Subheading = styled.div`
  color: ${Colors.white};
  font-family: "Open Sans", sans-serif;
  margin: 0px 150px;
  padding: 40px 0;
  font-weight: 700;
`;
export const Action = styled.div`
  margin-right: 200px;
`;
export const ActionText = styled.div`
  color: ${Colors.white};
  margin-bottom: 15px;
  font-family: "Open Sans", sans-serif;
  font-size: 18px;
  line-height: 25px;
  margin-top: 20px;
`;

export const ActionButton = styled.div`
  background-color: ${Colors.green};
  color: ${Colors.white};
  padding: 10px 15px;
  border-radius: 4px;
  font-weight: 700;
  font-family: "Open Sans", sans-serif;
  text-align: center;
`;

export const Banner = styled.div`
  background-color: ${Colors.lightBlue};
  padding: 40px 150px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const BannerText = styled.div`
  line-height: 50px;
  font-family: "Open Sans", sans-serif;
  font-size: 26px;
  font-weight: 900;
`;
export const BannerButton = styled.div`
  background-color: ${Colors.darkBlue};
  color: ${Colors.white};
  padding: 10px 15px;
  border-radius: 4px;
  font-weight: 700;
  font-family: "Open Sans", sans-serif;
  text-align: center;
`;

export const Cards = styled.div`
  background-color: ${Colors.gray};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
`;

export const Card = styled.div`
  background-color: ${Colors.gray};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  height: 300px;
  padding: 32px 0;
  color: ${Colors.darkBlue};
  padding: 0px 60px;
  border-right: 1px solid ${Colors.darkGray};
  &:last-child {
    border: none;
  }
`;
export const CardIcon = styled.div`
  padding: 10px 0 0px;
  font-size: 30px;
`;
export const CardTitle = styled.div`
  font-size: 20px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
`;
export const StyledButton = styled.div`
  background-color: ${Colors.blue};
  color: ${Colors.white};
  padding: 10px 15px;
  border-radius: 4px;
  font-weight: 700;
  font-family: "Open Sans", sans-serif;
  text-align: center;
  cursor: pointer;
`;

export const News = styled.div`
  font-family: "Open Sans", sans-serif;
  margin: 0px 150px;
  display: flex;
  padding: 40px 0;
`;
export const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-right: 40px;
`;

export const NewsHeading = styled.div`
  color: ${Colors.black};
  font-family: "Open Sans", sans-serif;
  font-weight: bold;
  font-size: 18px;
  line-height: 16px;
  margin-top: 20px;
  svg {
    display: inline;
    margin-right: 5px;
    padding-top: 4px;
  }
`;
export const NewsDescription = styled.div`
  font-family: "Open Sans", sans-serif;
  margin-top: 8px;
  font-size: 16px;
  margin-bottom: 10px;
`;

export const NewsDate = styled.div`
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  font-weight: 900;
  margin-top: 8px;
  color: ${Colors.darkBlue};
`;
export const NewsTitle = styled.div`
  font-family: "Open Sans", sans-serif;
  text-decoration: underline;
  color: ${Colors.blue};
`;

export const ResourcesContainer = styled.div`
  font-family: "Open Sans", sans-serif;
  display: flex;
  padding: 40px 0;
  background-color: ${Colors.gray};
`;
export const Resources = styled.div`
  font-family: "Open Sans", sans-serif;
  display: flex;
  flex-direction: column;
  margin: 0 150px;
  border-right: 1px solid ${Colors.darkGray};
`;
export const ResourceTitle = styled.div`
  font-family: "Open Sans", sans-serif;
  text-transform: uppercase;
  font-weight: 900;
  margin-bottom: 10px;
`;
export const ResourceLinks = styled.div`
  font-family: "Open Sans", sans-serif;
  display: flex;
`;
export const ResourceColumn = styled.div`
  font-family: "Open Sans", sans-serif;
  margin-right: 40px;
`;
export const ResourceLink = styled.div`
  font-family: "Open Sans", sans-serif;
  color: ${Colors.black};
  margin-bottom: 10px;
  width: 260px;
  font-size: 16px;
  cursor: pointer;
  svg {
    display: inline;
    padding-top: 4px;
    margin-right: 8px;
  }

  &:hover {
    text-decoration: underline;
  }
`;
export const Contact = styled.div`
  font-family: "Open Sans", sans-serif;
`;
export const DisclaimerContainer = styled.div`
  background-color: ${Colors.gray};
`;
export const Disclaimer = styled.div`
  display: flex;
  margin: 0 150px;
  justify-content: space-between;
  border-top: 1px solid ${Colors.black};
  border-bottom: 1px solid ${Colors.black};
  padding: 10px 0;
`;
export const DisclaimerLink = styled.a`
  font-family: "Open Sans", sans-serif;
  text-transform: uppercase;
  font-size: 10px;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;
export const FooterContainer = styled.div`
  background-color: ${Colors.gray};
`;
export const Footer = styled.div`
  display: flex;
  margin: 0 150px;
  justify-content: space-between;
  padding: 10px 0;
`;
export const FooterLink = styled.a`
  font-family: "Open Sans", sans-serif;
  text-transform: uppercase;
  font-size: 10px;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;
